export default __webpack_public_path__ + "static/media/paperclip-grey.fc888f3f.svg";